import { render, staticRenderFns } from "./AlertsProximity.vue?vue&type=template&id=8843a9c2&scoped=true"
import script from "./AlertsProximity.vue?vue&type=script&lang=js"
export * from "./AlertsProximity.vue?vue&type=script&lang=js"
import style0 from "./AlertsProximity.vue?vue&type=style&index=0&id=8843a9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8843a9c2",
  null
  
)

export default component.exports